/* eslint-disable react-hooks/exhaustive-deps */
import { capitalize } from "lodash";
import { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useAccount, useAccountContacts, useWorkspaceObjectsDetailed } from "../../../hooks/QueryHooks";
import useWorkspaceStore from "../../../store/workspace/workspaceStore";
import ProfileHeader from "./components/AccountProfileHeader";
import AccountRoutes from "./components/AccountRoutes";

const AccountDetailsPage = () => {
  const { accountId, workspaceId: routeWorkspaceId, viewId }: any = useParams();
  const navigate = useNavigate();
  const workspaceId = useWorkspaceStore((state) => state.workspace?.id);

  const accountData: any = useAccount({
    workspaceId,
    accountId,
    enabled: accountId !== "",
  });

  // Prefetch custom objects so data is cached when AccountRoutes renders
  useWorkspaceObjectsDetailed({
    workspaceId: workspaceId || "",
    enabled: !!workspaceId,
  });

  const contacts: any = useAccountContacts({
    workspaceId,
    accountId,
    enabled: accountId !== "",
  });

  useEffect(() => {
    if (accountData?.data?.name) {
      document.title = `${accountData?.data.name ? `${capitalize(accountData?.data.name)} | ` : ""}Account | Hyperengage`;
    }
  }, [accountData?.data?.name]);

  const handleBackToAccounts = () => {
    if (viewId) {
      navigate(`/home/${routeWorkspaceId}/view/${viewId}`);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="flex flex-col h-[calc(100vh-90px)] overflow-hidden bg-[#FCFCFC]">
      {/* Breadcrumb */}
      <div className="flex items-center gap-1.5 px-6 py-1.5 border-b border-gray-200 bg-white min-h-0">
        <button
          type="button"
          onClick={handleBackToAccounts}
          className="flex items-center gap-0.5 px-1.5 py-0.5 text-[12px] text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded transition-colors"
        >
          <ChevronLeft className="h-3.5 w-3.5" />
          Accounts
        </button>
        <span className="text-gray-300 text-[12px]">/</span>
        <span className="text-[12px] font-medium text-gray-900">
          {accountData?.data?.name || "Loading..."}
        </span>
      </div>

      {/* Main content: sidebar + tabs */}
      <div className="flex-1 flex overflow-hidden">
        {/* Sidebar */}
        <div className="w-[280px] min-w-[280px] border-r border-gray-200 bg-white overflow-y-auto">
          <div className="p-5 space-y-5">
            <ProfileHeader contacts={contacts?.data?.items} key={accountId} account={accountData?.data} />
          </div>
        </div>

        {/* Main content: tabs + outlet */}
        <div className="flex-1 flex flex-col overflow-hidden">
          <div className="border-b border-gray-200 bg-white px-6 pt-0.5">
            <AccountRoutes />
          </div>
          <div className="flex-1 overflow-y-auto bg-white">
            <div className="p-6">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDetailsPage;
